import React from 'react'

const ChapterIcon = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.3638 13.3638H9.31836V14.5638H15.3638V13.3638Z" fill={props.fill || "#0D1536"} fillOpacity="0.65"/>
        <path d="M9.31836 16H15.3638V17.2H9.31836V16Z" fill={props.fill || "#0D1536"} fillOpacity="0.65"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M19.6818 8.94127L15.9961 5.00556L15.0938 5.81984L18.0913 9.03175H13.5644V3H5V22H19.6818V8.94127ZM18.4583 20.7937H6.22348V4.20635H12.3409V10.2381H18.4583V20.7937Z" fill={props.fill || "#0D1536"} fillOpacity="0.65"/>
    </svg>

    
)

export default ChapterIcon
